import { useState, useRef, useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import NavBar from '../../../component/b2b/navBar/b2bNavBar'
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import { useForm } from 'react-hook-form';
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaCalculator, FaUser, FaShoppingCart, FaPlus, FaBox, FaTrash, FaShieldAlt } from 'react-icons/fa';
import { useMyContext } from '../../../context/MyContext';
import '../../../css/custom-scrollbar.css';
import Select from "react-dropdown-select";
import B2BViewRateForword from '../../../component/b2b/models/priceEstimatorModelB2b';
import { Base_Url, b2bAddShipment, getpincode, b2bWarehouseListAll, } from '../../../config/config';
import { toast } from 'react-toastify';
import Spinner from '../../../component/spinner/spinner';
import axios from 'axios';
import B2BUploadBulk from '../../../component/b2b/models/uploadBulkModel';

const schema = z.object({
    warehouse: z.string().optional(),
    firstName: z.string().min(1, "First Name is required").regex(/^[a-zA-Z\s]+$/, "First Name must only contain alphabetic characters"),
    lastName: z.string().min(1, "Last Name is required").regex(/^[a-zA-Z\s]+$/, "Last Name must only contain alphabetic characters"),
    email: z.string().email("Invalid email format").optional().or(z.literal("")),
    mobile: z.string()
        .length(10, "Mobile number must be exactly 10 digits")
        .regex(/^\d+$/, "Mobile number must be numeric"),
    address: z.string().min(10, "Full Address must be at least 10 characters"),
    pincode: z.string()
        .length(6, "Pincode should be exactly 6 characters")
        .regex(/^\d+$/, "Pincode must be numeric"),
    city: z.string().min(1, "City is required").regex(/^[a-zA-Z\s]+$/, "City must only contain alphabetic characters"),
    state: z.string().min(1, "State is required").regex(/^[a-zA-Z\s]+$/, "State must only contain alphabetic characters"),
    orderId: z.string().min(1, "Order ID is required"),

    invoiceAmount: z.string()
        .min(1, "Invoice Amount is required")
        .regex(/^\d+(\.\d+)?$/, "Invoice Amount must be numeric"),

    invoiceNumber: z.string()
        .min(1, "Invoice number is required")
        .regex(/^[A-Za-z0-9\/-]*$/, "Invoice number must only contain letters, numbers, / or -"),

    eWaybillNo: z.string()
        .max(12, "E-Waybill number must be at most 12 characters")
        .optional(), // initially optional

    paymentMode: z.string().min(1, "Payment Mode is required"),
    productDes: z.string().min(1, "Product Description is required"),
    codAmount: z.string().optional(),
    insurence: z.string().optional(),

    total_weight: z.string()
        .min(1, "Total Weight is required")
        .regex(/^\d*\.?\d+$/, "Total Weight must be a positive number and can be a float"),

    length: z.string()
        .regex(/^\d*\.?\d+$/, "Length must be a positive number and can be a float")
        .optional(),
    width: z.string()
        .regex(/^\d*\.?\d+$/, "Width must be a positive number and can be a float")
        .optional(),
    height: z.string()
        .regex(/^\d*\.?\d+$/, "Height must be a positive number and can be a float")
        .optional(),
}).refine(
    (data) => {
        // Convert invoiceAmount to number
        const amount = parseFloat(data.invoiceAmount);
        if (amount > 50000) {
            return !!data.eWaybillNo && data.eWaybillNo.trim() !== "";
        }
        return true;
    },
    {
        message: "E-Waybill number is required when Invoice Amount is greater than 50000",
        path: ["eWaybillNo"], // attach error to eWaybillNo field
    }
);


export default function B2BForwordShipment() {
    const { isDarkMode, isToggleSidebar } = useMyContext()
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [uploadBulkPopupOpen, setUploadBulkPopupOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [tableData, setTableData] = useState(null);
    const Navigation = useNavigate();
    const [wareHouseList, setwareHouseList] = useState([])
    const [wareHouseId, setwareHouseId] = useState('')
    const [wareHousePincode, setwareHousePincode] = useState('');
    const [reqBody, setReqBody] = useState([]);
    // const fileInputRef = useRef(null);
    const [totalBoxes, setTotalBoxes] = useState(0);
    const [selectedUnit, setSelectedUnit] = useState('cm');
    const [boxSets, setBoxSets] = useState([]);
    const [remainingBoxes, setRemainingBoxes] = useState(0);
    const [file, setFile] = useState(null);
    const [sec_file, set_Sec_File] = useState(null);
    const [lrnOption, setLrnOption] = useState('auto');
    const [manualLrn, setManualLrn] = useState('');

    const { register, handleSubmit, formState: { errors }, reset, trigger, watch, setValue } = useForm({
        resolver: zodResolver(schema),
    });

    const handleViewClick = () => {
        setIsPopupOpen(true);
    };
    const handleClose = () => {
        setIsPopupOpen(false);
    };

    const UploadBulkViewClick = () => {
        setUploadBulkPopupOpen(true);

    }

    const handleCloseUploadBulk = () => {
        setUploadBulkPopupOpen(false);

    };

    const pincode = watch("pincode");

    useEffect(() => {
        if (pincode && pincode.length === 6) {
            fetchPincodeData(pincode);
        }
    }, [pincode]);


    const fetchPincodeData = async (pincode) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;
        try {
            // const response = await fetch(`http://192.168.1.36/backendci4/api/getpincode?pincode=${pincode}`, {
            const response = await fetch(urlgetPincode, {
                method: 'GET',
                headers: {
                    // 'token': "eyJ1c2VyX2lkIjoiNTkiLCJleHBpcmVzX2F0IjoxNzI4NzEzMzM4fQ==",
                    'token': token,
                    'cus_id': cus_id,
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();
            if (data && data.status === "SUCCESS") {
                let { city, state } = data.data[0];

                city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
                state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();

                setValue("city", city);
                setValue("state", state);
            }


            else if (data && data.message === "Unauthorized access - Invalid token") {
                toast.error(data.message + " Please login Again");
            }

            else if (data && data.status === "FAIL") {
                toast.error("Something Went Wrong Please Try Again With Another Pincode");
            }
            else {
                toast.error("Failed to fetch city and state data");
            }
        } catch (error) {
            console.error('Error fetching pincode data:', error);
            toast.error("Error fetching pincode data");
        }
    };

    const paymentMode = watch("paymentMode");

    useEffect(() => {
        if (paymentMode === "prepaid") {
            setValue("codAmount", "0");
        } else if (paymentMode === "cod") {
            setValue("codAmount", "");
        }
    }, [paymentMode, setValue]);

    const handleInputChange = (event) => {
        const { value, id } = event.target;

        if (['pincode', 'mobile', 'boxQty'].includes(id)) {
            const filteredValue = value.replace(/[^0-9]/g, '');
            event.target.value = filteredValue;
        }

        // Allow only letters and spaces for text fields
        if (['firstName', 'lastName', 'city', 'state'].includes(id)) {
            const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
            event.target.value = filteredValue;
        }
    };

    useEffect(() => {
        fetchWareHouseList()
    }, [])

    const fetchWareHouseList = async () => {
        const token = localStorage.getItem('token');
        const cusid = localStorage.getItem('cus_id');
        const headers = new Headers({
            'token': token,
            'cus_id': cusid,
            'Content-Type': 'application/json'
        });

        try {
            const response = await fetch(Base_Url + b2bWarehouseListAll, {

                method: 'GET',
                headers: headers
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            const transformedData = data.data.map(warehouse => ({
                value: warehouse.warehouse_id,
                label: warehouse.name,
                pincode: warehouse.pincode
            }));
            setwareHouseList(transformedData)
        } catch (error) {
            console.error('Error:', error);
        }
    }


    const handleNaviagtion = () => {
        Navigation("/b2b/dashboard");
    }


    const onSubmit = async (data) => {
        setIsSubmitting(true);
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const invoiceAmount = parseFloat(data.invoiceAmount) || 0;

        // 1️⃣ Validate mandatory invoice file
        if (!invoiceFileName) {
            toast.error("Invoice document is mandatory.");
            setIsSubmitting(false);
            return;
        }

        // 2️⃣ Conditionally validate secondary document
        if (invoiceAmount > 50000 && !secondaryFile) {
            toast.error("Secondary document is mandatory for amounts greater than 50,000.");
            setIsSubmitting(false);
            return;
        }

        // 3️⃣ BoxSet validation (your existing logic)
        if (boxSets && boxSets.length > 0) {
            const invalidBoxSet = boxSets.find(box =>
                !box.quantity || !box.length || !box.width || !box.height ||
                box.quantity <= 0 || box.length <= 0 || box.width <= 0 || box.height <= 0
            );

            if (invalidBoxSet) {
                toast.error("Please fill all box set dimensions with positive values");
                setIsSubmitting(false);
                return;
            }
        }

        try {
            const formData = new FormData();

            // Append fields as before
            formData.append('warehouse_id', wareHouseId || '');
            formData.append('total_boxes', totalBoxes || '');
            formData.append('payment_mode', data.paymentMode || '');
            formData.append('cod_amount', data.codAmount || '0');
            formData.append('total_weight', data.total_weight || '');

            // Dropoff location
            const dropoffLocation = {
                consignee_name: `${data.firstName} ${data.lastName}`,
                address: data.address || '',
                city: data.city || '',
                state: data.state || '',
                zip: data.pincode || '',
                phone: data.mobile || '',
                email: data.email || '',
            };
            formData.append('dropoff_location', JSON.stringify(dropoffLocation));

            // Invoices
            const invoices = [{
                ewaybill: data.eWaybillNo,
                inv_num: data.invoiceNumber,
                inv_amt: data.invoiceAmount,
                inv_qr_code: ""
            }];
            formData.append('invoices', JSON.stringify(invoices));

            // Shipment details
            const shipmentDetails = [{
                order_id: data.orderId || '',
                box_count: totalBoxes || 1,
                description: data.productDes || '',
                weight: parseFloat(data.total_weight) || 0,
                waybills: [],
                master: "False"
            }];
            formData.append('shipment_details', JSON.stringify(shipmentDetails));

            // Dimensions
            const dimensions = boxSets && boxSets.length > 0
                ? boxSets.map(boxSet => ({
                    box_count: parseInt(boxSet.quantity) || 1,
                    length: parseFloat(boxSet.length) || 0,
                    width: parseFloat(boxSet.width) || 0,
                    height: parseFloat(boxSet.height) || 0
                }))
                : [{
                    box_count: 1,
                    length: parseFloat(data.length) || 0,
                    width: parseFloat(data.width) || 0,
                    height: parseFloat(data.height) || 0
                }];
            formData.append('dimensions', JSON.stringify(dimensions));

            // Document data
            const docData = [{
                doc_type: "INVOICE_COPY",
                doc_meta: {
                    invoice_num: [data.orderId || '']
                }
            }];
            formData.append('doc_data', JSON.stringify(docData));

            // Append files
            if (file) formData.append('doc_file', file); // Invoice file
            if (sec_file) formData.append('sec_doc', sec_file);

            // Billing address
            const billingAddress = {
                name: `${data.firstName} ${data.lastName}`,
                company: "pickupxpress",
                consignor: data.firstName || '',
                address: data.address || '',
                city: data.city || '',
                state: data.state || '',
                pin: data.pincode || '',
                phone: data.mobile || '',
                pan_number: "ABCDE1234F",
                gst_number: "09AAACH7409R1ZZ"
            };
            formData.append('billing_address', JSON.stringify(billingAddress));

            // Additional fields
            formData.append('insurence', data.insurence === 'carrierRisk' ? 'Carrier' : 'Owner');
            formData.append('fm_pickup', 'True');
            formData.append('retailer_id', '2');

            // LRN  
            if (lrnOption === 'manual' && manualLrn) {
                formData.append('lrn', manualLrn);
            }

            // Send request
            const response = await axios.post(Base_Url + b2bAddShipment, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'token': token,
                    'cus_id': cus_id,
                },
            });

            if (response.data.status === "SUCCESS") {
                setTimeout(() => toast.success("Shipment added successfully ....!"), 1000);
                setTableData(response.data);
                setIsSubmitting(false);
                handleNaviagtion();
            } else {
                toast.error(response.data.message);
                setIsSubmitting(false);
            }
        } catch (error) {
            if (error.response) {
                const { data } = error.response;
                if (data.messages && typeof data.messages === 'object') {
                    Object.values(data.messages).forEach((msg) => toast.error(msg));
                } else if (data.message) {
                    toast.error(data.message);
                }
                setIsSubmitting(false);
            } else if (error.request) {
                toast.error("No response from server. Please check your network.");
                setIsSubmitting(false);
            } else {
                toast.error("An unexpected error occurred.");
                setIsSubmitting(false);
            }
        }
    };

    // Error handler for form validation
    const onErrors = (errors) => {

        // Log each error field
        Object.keys(errors).forEach(field => {
        });

        // Show first error as toast
        const firstErrorKey = Object.keys(errors)[0];
        if (firstErrorKey && errors[firstErrorKey]) {
            toast.error(errors[firstErrorKey].message);
        }
    };

    const handleSelectChange = (selected) => {
        if (selected.length > 0) {
            const selectedItem = selected[0];
            setwareHouseId(selectedItem.value);
            setwareHousePincode(selectedItem.pincode);
        }
    };

    const handleTotalBoxesChange = (e) => {
        const value = parseInt(e.target.value) || 0;
        setTotalBoxes(value);
        setRemainingBoxes(value);
        setBoxSets([]);
    };

    const handleAddBoxSet = () => {
        if (remainingBoxes > 0) {
            setBoxSets([...boxSets, { quantity: remainingBoxes, length: '', width: '', height: '' }]);
            setRemainingBoxes(0);
        }
    };

    const handleBoxSetChange = (index, field, value) => {
        const newBoxSets = [...boxSets];
        const updatedBoxSet = { ...newBoxSets[index] };

        if (field === 'quantity') {
            const newQuantity = parseInt(value) || 0;
            const otherBoxesQuantity = boxSets.reduce((sum, box, i) =>
                i !== index ? sum + (parseInt(box.quantity) || 0) : sum, 0
            );

            if (newQuantity + otherBoxesQuantity <= totalBoxes) {
                updatedBoxSet.quantity = newQuantity;
                newBoxSets[index] = updatedBoxSet;
                setBoxSets(newBoxSets);
                setRemainingBoxes(totalBoxes - (newQuantity + otherBoxesQuantity));
            }
        } else {
            // For length, width, height - ensure they're stored as strings initially for input compatibility
            updatedBoxSet[field] = value;
            newBoxSets[index] = updatedBoxSet;
            setBoxSets(newBoxSets);
        }

    };

    const handleDeleteBoxSet = (index) => {
        const deletedQuantity = boxSets[index].quantity || 0;
        const newBoxSets = boxSets.filter((_, i) => i !== index);
        setBoxSets(newBoxSets);

        // Recalculate remaining boxes
        const totalUsedBoxes = newBoxSets.reduce((sum, box) => sum + (box.quantity || 0), 0);
        setRemainingBoxes(totalBoxes - totalUsedBoxes);
    };


    const [invoiceFileName, setInvoiceFileName] = useState('');
    const [secondaryFile, setSecondaryFile] = useState('');

    // const handleFileChange = (event) => {
    //     const selectedFile = event.target.files[0];
    //     if (selectedFile) {
    //         const inputId = event.target.id;

    //         // Update the file state
    //         setFile(selectedFile);

    //         if (inputId === 'invoiceDocs') {
    //             setInvoiceFileName(selectedFile.name);
    //         } else if (inputId === 'secondaryDocs') {
    //             setSecondaryFile(selectedFile.name);
    //         }

    //         // Your existing file handling logic here
    //     } 
    // };


    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const inputId = event.target.id;

            if (inputId === 'invoiceDocs') {
                setFile(selectedFile); // store invoice file
                setInvoiceFileName(selectedFile.name); // store invoice file name
            } else if (inputId === 'secondaryDocs') {
                set_Sec_File(selectedFile); // store secondary file
                setSecondaryFile(selectedFile.name); // store secondary file name
            }
        }
    };


    return (
        <>
            <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                <div className="z-10">
                    <NavBar />
                </div>
                <div className="flex flex-1 overflow-hidden">
                    {isToggleSidebar && (
                        <div
                            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                            style={
                                window.innerWidth < 768
                                    ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                    : {}
                            } >
                            <Sidebar />
                        </div>
                    )}
                    <div
                        className={`flex-1  bg-white sm:mt-3 overflow-auto transition-all duration-300 custom-scrollbar  rounded-custom md:ml-4 md:mr-4 md:mr-4 md:mb-4 ${isToggleSidebar ? 'md:ml-0' : 'md:ml-0'} ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white shadow-custom-dark" : "bg-white"}`}
                    >
                        <div className="container overflow-x-hidden mx-auto pl-6 pr-6 pt-4 pb-2 ">
                            <div className="flex flex-col md:flex-row mb-3 gap-2 md:gap-8">
                                <button onClick={handleNaviagtion}
                                    className="w-full md:w-[48%] bg-customPurple hover:bg-purple-700 text-white py-2 rounded-md flex items-center justify-center">
                                    <IoMdArrowRoundBack className="mr-2" />
                                    Create Forword Order
                                </button>
                                <button
                                    className="w-full md:w-[48%] bg-customPurple hover:bg-purple-700 text-white py-2 rounded-md flex items-center justify-center"
                                    onClick={UploadBulkViewClick}
                                >
                                    <FaBox className="mr-2" />
                                    Upload Bulk
                                </button>
                            </div>
                            <B2BUploadBulk
                                isopen={uploadBulkPopupOpen}
                                onClose={handleCloseUploadBulk}
                            />
                            <form onSubmit={handleSubmit(onSubmit, onErrors)}>
                                <form onSubmit={handleSubmit(onSubmit, onErrors)}>
                                    <div className="px-4 pt-4 pb-4 mb-2 font-sans text-xs shadow-md  rounded-custom dark:shadow-custom-dark rounded-custom w-full">
                                        <h2 className="text-base font-bold mb-2 text-custom-blue flex items-center">
                                            <FaUser className="mr-1 text-custom-blue text-sm" />
                                            Customer Details
                                        </h2>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                                            {/* Row 1: Warehouse, First Name, Last Name */}
                                            <div className="relative">
                                                <label htmlFor="warehouse" className="block text-xs font-medium mb-1">Warehouse</label>
                                                <select
                                                    id="warehouse"
                                                    value={wareHouseId}
                                                    {...register("warehouse")}
                                                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline pr-8
                        ${isDarkMode ? "bg-darkmodeColor text-white" : "bg-white text-darkmodeColor"}`}
                                                    onChange={(e) => {
                                                        const selectedValue = e.target.value;
                                                        const selectedItem = wareHouseList.find((item) => item.value === selectedValue);

                                                        if (selectedItem) {
                                                            setwareHouseId(selectedItem.value);
                                                            setwareHousePincode(selectedItem.pincode);
                                                        }

                                                        trigger("warehouse");
                                                        setValue("warehouse", selectedValue);
                                                    }}
                                                >
                                                    <option value="">Select Warehouse</option>
                                                    {wareHouseList.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </select>

                                                <div className="pointer-events-none absolute inset-y-0 right-2 top-5 flex items-center">
                                                    <svg
                                                        className={`w-3 h-3 ${isDarkMode ? "text-white" : "text-darkmodeColor"}`}
                                                        fill="currentColor"
                                                        viewBox="0 0 20 20"
                                                    >
                                                        <path d="M7 7l3-3 3 3H7zm6 6l-3 3-3-3h6z" />
                                                    </svg>
                                                </div>

                                                {errors.warehouse && (
                                                    <p className="text-red-500 text-xs mt-0.5">{errors.warehouse.message}</p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="firstName" className="block text-xs font-medium mb-1">First Name</label>
                                                <input
                                                    id="firstName"
                                                    {...register("firstName")}
                                                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="text"
                                                    onChange={handleInputChange}
                                                    placeholder="Enter first name"
                                                />
                                                {errors.firstName && <p className="text-red-500 text-xs mt-0.5">{errors.firstName.message}</p>}
                                            </div>

                                            <div>
                                                <label htmlFor="lastName" className="block text-xs font-medium mb-1">Last Name</label>
                                                <input
                                                    id="lastName"
                                                    {...register("lastName")}
                                                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="text"
                                                    onChange={handleInputChange}
                                                    placeholder="Last name"
                                                />
                                                {errors.lastName && <p className="text-red-500 text-xs mt-0.5">{errors.lastName.message}</p>}
                                            </div>

                                            {/* Row 2: Email, Mobile */}
                                            <div>
                                                <label htmlFor="email" className="block text-xs font-medium mb-1">Email</label>
                                                <input
                                                    id="email"
                                                    {...register("email")}
                                                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="email"
                                                    placeholder="Enter email"
                                                />
                                            </div>

                                            <div>
                                                <label htmlFor="mobile" className="block text-xs font-medium mb-1">Mobile No.</label>
                                                <input
                                                    id="mobile"
                                                    maxLength="10"
                                                    {...register("mobile")}
                                                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="tel"
                                                    onChange={handleInputChange}
                                                    placeholder="Enter 10 digit mobile no."
                                                />
                                                {errors.mobile && <p className="text-red-500 text-xs mt-0.5">{errors.mobile.message}</p>}
                                            </div>

                                            {/* LRN Option - Positioned next to Mobile */}
                                            <div>
                                                <label className="block text-xs font-medium mb-1">LRN Option</label>
                                                <div className="flex flex-col gap-1">
                                                    {/* Radio buttons and input in horizontal layout */}
                                                    <div className="flex items-center gap-2">
                                                        <div className="flex gap-2 flex-shrink-0">
                                                            <label className="flex items-center gap-1">
                                                                <input
                                                                    type="radio"
                                                                    name="lrnOption"
                                                                    value="auto"
                                                                    checked={lrnOption === 'auto'}
                                                                    onChange={() => setLrnOption('auto')}
                                                                    className="accent-blue-600 w-3 h-3"
                                                                />
                                                                <span className="text-xs">Auto</span>
                                                            </label>

                                                            <label className="flex items-center gap-1">
                                                                <input
                                                                    type="radio"
                                                                    name="lrnOption"
                                                                    value="manual"
                                                                    checked={lrnOption === 'manual'}
                                                                    onChange={() => setLrnOption('manual')}
                                                                    className="accent-blue-600 w-3 h-3"
                                                                />
                                                                <span className="text-xs">Manual</span>
                                                            </label>
                                                        </div>

                                                        {/* Manual LRN input - positioned to the right */}
                                                        {lrnOption === 'manual' && (
                                                            <div className="flex-1">
                                                                <input
                                                                    type="text"
                                                                    name="manualLrn"
                                                                    placeholder="Enter LRN manually"
                                                                    value={manualLrn}
                                                                    onChange={(e) => setManualLrn(e.target.value)}
                                                                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode
                                                                        ? 'bg-darkmodeColor text-white placeholder-white shadow-none'
                                                                        : 'bg-white text-darkmodeColor'
                                                                        }`}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Error message */}
                                                    {errors.manualLrn && (
                                                        <p className="text-red-500 text-xs">{errors.manualLrn.message}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Row 3: Address, Pincode, City */}
                                            <div>
                                                <label htmlFor="address" className="block text-xs font-medium mb-1">Full Address</label>
                                                <input
                                                    id="address"
                                                    {...register("address")}
                                                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="text"
                                                    placeholder="Enter full address"
                                                />
                                                {errors.address && <p className="text-red-500 text-xs mt-0.5">{errors.address.message}</p>}
                                            </div>

                                            <div>
                                                <label htmlFor="pincode" className="block text-xs font-medium mb-1">Pincode</label>
                                                <input
                                                    id="pincode"
                                                    maxLength="6"
                                                    {...register("pincode")}
                                                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="text"
                                                    placeholder="Enter pincode"
                                                />
                                                {errors.pincode && <p className="text-red-500 text-xs mt-0.5">{errors.pincode.message}</p>}
                                            </div>

                                            <div>
                                                <label htmlFor="city" className="block text-xs font-medium mb-1">City</label>
                                                <input
                                                    id="city"
                                                    {...register("city")}
                                                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="text"
                                                    onChange={handleInputChange}
                                                    disabled
                                                    placeholder="City"
                                                />
                                                {errors.city && <p className="text-red-500 text-xs mt-0.5">{errors.city.message}</p>}
                                            </div>

                                            {/* Row 4: State */}
                                            <div>
                                                <label htmlFor="state" className="block text-xs font-medium mb-1">State</label>
                                                <input
                                                    id="state"
                                                    {...register("state")}
                                                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="text"
                                                    onChange={handleInputChange}
                                                    disabled
                                                    placeholder="State"
                                                />
                                                {errors.state && <p className="text-red-500 text-xs mt-0.5">{errors.state.message}</p>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col md:flex-row gap-2 font-sans w-full">
                                        <div className="px-4 pt-4 pb-4 mb-2 flex-1 shadow-md dark:shadow-custom-dark rounded-custom">
                                            <h2 className="text-base font-bold mb-2 text-custom-blue flex items-center">
                                                <FaShoppingCart className="mr-1 text-custom-blue text-sm" />
                                                Order Details
                                            </h2>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                                <div>
                                                    <label htmlFor="orderId" className="block text-xs font-medium mb-1">Order ID</label>
                                                    <input
                                                        id="orderId"
                                                        {...register("orderId")}
                                                        className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                        type="text"
                                                        placeholder="Enter Order ID"
                                                    />
                                                    {errors.orderId && <p className="text-red-500 text-xs mt-0.5">{errors.orderId.message}</p>}
                                                </div>

                                                <div>
                                                    <label htmlFor="productDes" className="block text-xs font-medium mb-1">Product Description</label>
                                                    <input
                                                        id="productDes"
                                                        {...register("productDes")}
                                                        className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                        type="text"
                                                        placeholder="Product Description"
                                                    />
                                                    {errors.productDes && <p className="text-red-500 text-xs mt-0.5">{errors.productDes.message}</p>}
                                                </div>

                                                <div>
                                                    <label htmlFor="paymentMode" className="block text-xs font-medium mb-1">Payment Mode</label>
                                                    <select
                                                        id="paymentMode"
                                                        {...register("paymentMode")}
                                                        className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    >
                                                        <option value="prepaid">Prepaid</option>
                                                        <option value="cod">COD</option>
                                                    </select>
                                                    {errors.paymentMode && <p className="text-red-500 text-xs mt-0.5">{errors.paymentMode.message}</p>}
                                                </div>

                                                <div>
                                                    <label htmlFor="codAmount" className="block text-xs font-medium mb-1">Amount</label>
                                                    <input
                                                        id="codAmount"
                                                        {...register("codAmount")}
                                                        className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                        type="text"
                                                        placeholder="Amount"
                                                        disabled={paymentMode !== "cod"}
                                                    />
                                                    {errors.codAmount && <p className="text-red-500 text-xs mt-0.5">{errors.codAmount.message}</p>}
                                                </div>
                                            </div>

                                            {/* Insurance Section */}
                                            <div className="mt-3 p-3 border rounded-custom shadow-md dark:shadow-custom-dark">
                                                <h3 className="text-sm font-semibold flex items-center text-custom-blue">
                                                    <FaShieldAlt className="mr-1 text-custom-blue text-xs" />
                                                    Insure your shipment
                                                </h3>
                                                <p className="text-xs text-gray-600 dark:text-gray-300 mt-0.5">
                                                    Are you sure you want to ship the item at your own risk?
                                                </p>
                                                <div className="mt-2 space-y-2">
                                                    <label className="flex items-center space-x-2 cursor-pointer text-xs">
                                                        <input
                                                            type="radio"
                                                            {...register("insurance")}
                                                            value="ownerRisk"
                                                            className="form-radio text-custom-blue focus:ring-custom-blue w-3 h-3"
                                                        />
                                                        <span className="font-medium text-custom-blue">
                                                            Yes,(The charges will be applied as per agreement)
                                                        </span>
                                                    </label>

                                                    <label className="flex items-center space-x-2 cursor-pointer">
                                                        <input
                                                            type="radio"
                                                            {...register("insurance")}
                                                            value="carrierRisk"
                                                            className="form-radio text-custom-blue focus:ring-custom-blue w-3 h-3"
                                                        />
                                                        <span className="font-medium text-xs text-custom-blue">
                                                            No,<span className="text-custom-blue">(The nominal charges will be applied)</span>
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="px-4 pt-4 pb-4 mb-2 flex-1 font-sans rounded-custom shadow-md dark:shadow-custom-dark">
                                            <h2 className="text-base font-bold mb-2 text-blue-600 flex items-center">
                                                <FaBox className="mr-1 text-sm" />
                                                Box Details
                                            </h2>
                                            <div className="mb-3">
                                                <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                                                    <div>
                                                        <label className="block text-xs font-medium mb-1">Total Boxes</label>
                                                        <input
                                                            type="number"
                                                            onChange={handleTotalBoxesChange}
                                                            className="p-1.5 text-xs w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
                                                            placeholder="Enter total boxes"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium mb-1">Total Weight (kg)</label>
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            {...register("total_weight")}
                                                            className="p-1.5 text-xs w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
                                                            placeholder="Enter total weight"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium mb-1">Unit</label>
                                                        <select
                                                            className="p-1.5 text-xs w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
                                                        >
                                                            <option value="cm">Centimeters (cm)</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {boxSets.map((boxSet, index) => (
                                                <div key={index} className="mb-3 p-2 border rounded-lg bg-gray-50">
                                                    <div className="grid grid-cols-1 md:grid-cols-5 gap-2 mb-2">
                                                        <div>
                                                            <label className="block text-xs font-medium mb-1">Quantity</label>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                max={remainingBoxes + (boxSet.quantity || 0)}
                                                                value={boxSet.quantity || ''}
                                                                onChange={(e) => handleBoxSetChange(index, 'quantity', e.target.value)}
                                                                className={`p-1.5 text-xs w-full border rounded-lg ${!boxSet.quantity || boxSet.quantity <= 0 ? 'border-red-500' : 'border-gray-300'
                                                                    }`}
                                                                required
                                                            />
                                                        </div>
                                                        <div>
                                                            <label className="block text-xs font-medium mb-1">Length({selectedUnit})</label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                min="0.01"
                                                                value={boxSet.length || ''}
                                                                onChange={(e) => handleBoxSetChange(index, 'length', e.target.value)}
                                                                className={`p-1.5 text-xs w-full border rounded-lg ${!boxSet.length || parseFloat(boxSet.length) <= 0 ? 'border-red-500' : 'border-gray-300'
                                                                    }`}
                                                                required
                                                            />
                                                        </div>
                                                        <div>
                                                            <label className="block text-xs font-medium mb-1">Width({selectedUnit})</label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                min="0.01"
                                                                value={boxSet.width || ''}
                                                                onChange={(e) => handleBoxSetChange(index, 'width', e.target.value)}
                                                                className={`p-1.5 text-xs w-full border rounded-lg ${!boxSet.width || parseFloat(boxSet.width) <= 0 ? 'border-red-500' : 'border-gray-300'
                                                                    }`}
                                                                required
                                                            />
                                                        </div>
                                                        <div>
                                                            <label className="block text-xs font-medium mb-1">Height({selectedUnit})</label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                min="0.01"
                                                                value={boxSet.height || ''}
                                                                onChange={(e) => handleBoxSetChange(index, 'height', e.target.value)}
                                                                className={`p-1.5 text-xs w-full border rounded-lg ${!boxSet.height || parseFloat(boxSet.height) <= 0 ? 'border-red-500' : 'border-gray-300'
                                                                    }`}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="flex items-end">
                                                            <button
                                                                type="button"
                                                                onClick={() => handleDeleteBoxSet(index)}
                                                                className="p-1.5 text-red-500 hover:text-red-700"
                                                                title="Delete box set"
                                                            >
                                                                <FaTrash size="16" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                            <div className="flex items-center justify-between">
                                                <button
                                                    onClick={handleAddBoxSet}
                                                    disabled={remainingBoxes === 0}
                                                    className={`flex items-center px-3 py-1.5 text-xs rounded-lg ${remainingBoxes === 0 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600 text-white'
                                                        }`}
                                                >
                                                    <FaPlus className="mr-1 text-xs" />
                                                    Add Box Set
                                                </button>
                                                {remainingBoxes > 0 && (
                                                    <span className="text-xs text-gray-600">Remaining boxes: {remainingBoxes}</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col md:flex-row gap-2 font-sans w-full">
                                        <div className="px-4 pt-4 pb-4 mb-2 flex-1 shadow-md dark:shadow-custom-dark rounded-custom">
                                            <h2 className="text-base font-bold mb-2 text-custom-blue flex items-center">
                                                <FaShoppingCart className="mr-1 text-custom-blue text-sm" />
                                                Invoice Details
                                            </h2>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                                <div>
                                                    <label htmlFor="invoiceNumber" className="block text-xs font-medium mb-1">Invoice Number</label>
                                                    <input
                                                        id="invoiceNumber"
                                                        {...register("invoiceNumber")}
                                                        className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                        type="text"
                                                        placeholder="Enter Invoice Number"
                                                    />
                                                    {errors.invoiceNumber && <p className="text-red-500 text-xs mt-0.5">{errors.invoiceNumber.message}</p>}
                                                </div>
                                                <div>
                                                    <label htmlFor="eWaybillNo" className="block text-xs font-medium mb-1">E-WaybillNo</label>
                                                    <input
                                                        id="eWaybillNo"
                                                        {...register("eWaybillNo")}
                                                        className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                        type="text"
                                                        placeholder="E-WaybillNo"
                                                    />
                                                    {errors.eWaybillNo && <p className="text-red-500 text-xs mt-0.5">{errors.eWaybillNo.message}</p>}
                                                </div>
                                                <div>
                                                    <label htmlFor="totalAmount" className="block text-xs font-medium mb-1">Amount</label>
                                                    <input
                                                        id="totalAmount"
                                                        {...register("invoiceAmount")}
                                                        className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                        type="text"
                                                        placeholder="Total Amount"
                                                    />
                                                    {errors.totalAmount && <p className="text-red-500 text-xs mt-0.5">{errors.totalAmount.message}</p>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="px-4 pt-4 pb-4 mb-2 flex-1 bg-white dark:bg-darkmodeColor shadow-lg rounded-lg">
                                            <h2 className="text-base font-bold mb-3 text-custom-blue dark:text-blue-400 flex items-center gap-1">
                                                <svg
                                                    className="w-4 h-4"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                                                    />
                                                </svg>
                                                Invoice Documents
                                            </h2>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                                <div>
                                                    <label htmlFor="invoiceDocs" className="block text-xs font-medium mb-1 dark:text-gray-200">
                                                        Invoice Documents
                                                        <span className="text-xs text-gray-500 dark:text-gray-400 ml-1">(PDF/PNG/JPG/JPEG)</span>
                                                    </label>
                                                    <div className="relative border-2 border-dashed border-gray-300 dark:border-blue-500/40 rounded-lg p-3 hover:border-blue-400 transition-colors">
                                                        <input
                                                            id="invoiceDocs"
                                                            type="file"
                                                            accept=".pdf,.png,.jpg,.jpeg"
                                                            onChange={handleFileChange}
                                                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                                        />
                                                        <div className="text-center">
                                                            <p className="text-xs text-gray-600 dark:text-gray-300">
                                                                Drop files here or click to upload
                                                            </p>
                                                        </div>
                                                    </div>
                                                    {invoiceFileName && (
                                                        <div className="mt-1 p-1.5 bg-blue-50 dark:bg-blue-900/20 rounded-md">
                                                            <p className="text-xs text-blue-700 dark:text-blue-300 flex items-center gap-1">
                                                                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                                                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
                                                                </svg>
                                                                {invoiceFileName}
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                                <div>
                                                    <label htmlFor="secondaryDocs" className="block text-xs font-medium mb-1 dark:text-gray-200">
                                                        Secondary Documents
                                                        <span className="text-xs text-gray-500 dark:text-gray-400 ml-1">(PDF/PNG/JPG/JPEG)</span>
                                                    </label>
                                                    <div className="relative border-2 border-dashed border-gray-300 dark:border-blue-500/40 rounded-lg p-3 hover:border-blue-400 transition-colors">
                                                        <input
                                                            id="secondaryDocs"
                                                            type="file"
                                                            onChange={handleFileChange}
                                                            accept=".pdf,.png,.jpg,.jpeg"
                                                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                                        />
                                                        <div className="text-center">
                                                            <p className="text-xs text-gray-600 dark:text-gray-300">
                                                                Drop files here or click to upload
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {secondaryFile && (
                                                        <div className="mt-1 p-1.5 bg-blue-50 dark:bg-blue-900/20 rounded-md">
                                                            <p className="text-xs text-blue-700 dark:text-blue-300 flex items-center gap-1">
                                                                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                                                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
                                                                </svg>
                                                                {secondaryFile}
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div className="flex justify-center mb-3">
                                    <button
                                        type="submit"
                                        className="w-full md:w-[40%] bg-customPurple hover:bg-purple-700 text-white py-2 rounded-md flex items-center justify-center"
                                    >
                                        {isSubmitting ? <Spinner /> : 'Add order'}
                                        <FaCalculator className="ml-2" />
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <B2BViewRateForword
                    isopen={isPopupOpen}
                    onClose={handleClose}
                    data={tableData}
                    reqBody={reqBody}
                />
            </div>
        </>
    )
}


